var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Component, h } from 'preact';
import { disabledClickDelay, dispatchGlobalEvent, inContext, } from '../../services/UtilsTool';
import './Dropdown.scss';
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.srwrdsInfoDisabled = false;
        _this.srwrdsOpenChestsDisabled = false;
        _this.imagePaths = {
            chests: _this.props.cvl2 ? require('../../../public/chests-2.png') : require('../../../public/chests.png'),
            nochest: require('../../../public/no-chests.png'),
            chestanim: require('../../../public/srwrds-chest-anim.png'),
        };
        _this.getImages = {
            chest: { 'background-image': 'url(' + _this.imagePaths.chests + ')' },
            chestanim: { 'background-image': 'url(' + _this.imagePaths.chestanim + ')' },
        };
        _this.onMouseEnter = function () {
            _this.props.onMouseEnter();
        };
        _this.onMouseLeave = function () {
            setTimeout(function () {
                _this.props.onMouseLeave();
            }, 80);
        };
        _this.state = {
            panelId: 0,
            panelOpened: false,
            showExchange: false,
            exchangeDisabled: false
        };
        _this.togglePanel = function (panelId) {
            _this.setState(function (prevState) { return ({
                panelId: panelId,
                panelOpened: prevState.panelOpened === _this.state.panelOpened &&
                    prevState.panelId === panelId
                    ? !prevState.panelOpened
                    : true,
            }); });
        };
        _this.panelItem = function (panelId, copy, icon, panelInfo, panelCta) {
            return (h("div", { className: 'srwrds-panel' +
                    (panelInfo ? ' srwrds-has-info' : '') +
                    (_this.state.panelOpened && _this.state.panelId === panelId
                        ? ' srwrds-is-opened'
                        : ''), onClick: panelInfo && _this.togglePanel.bind(_this, panelId) },
                icon,
                copy,
                panelInfo && (h("svg", { height: "6", viewBox: "0 0 12 6", width: "12", className: "srwrds-arrow" },
                    h("path", { d: "m10 393.06065-5 5-5-5", fill: "none", stroke: "#000", transform: "translate(1 -393)" }))),
                panelInfo && (h("div", { className: "srwrds-info" },
                    panelInfo,
                    panelCta))));
        };
        _this.transformScale = function (scaling) {
            return {
                transform: 'scale(' + 1 / scaling + ')',
            };
        };
        _this.showExchangeForm = function () {
            _this.setState({ showExchange: true });
        };
        _this.hideExchangeForm = function () {
            _this.setState({ showExchange: false });
        };
        _this.showMoreInformation = function () {
            if (!_this.srwrdsInfoDisabled) {
                _this.dispatchGlobalEvt(Dropdown.EVENTS.INFO);
            }
        };
        return _this;
    }
    Dropdown.prototype.componentDidUpdate = function () {
        if (this.props.hideExchangeView && this.state.showExchange) {
            this.setState({ showExchange: false });
        }
    };
    Dropdown.prototype.setDisabledStatus = function (event, status) {
        this[event + "Disabled"] = status; // dynamically set the values
        this.forceUpdate();
    };
    Dropdown.prototype.dispatchGlobalEvt = function (event) {
        var _this = this;
        this.setDisabledStatus(event, true);
        setTimeout(function () {
            dispatchGlobalEvent(event);
        }, 1); // delay sending the event.
        setTimeout(function () {
            _this.setDisabledStatus(event, false);
        }, disabledClickDelay);
        this.onMouseLeave();
    };
    Dropdown.prototype.getChests = function (value) {
        var chests = null;
        if (value > 0 && value <= 99) {
            chests = value;
        }
        else if (value > 99) {
            chests = '99+';
        }
        return chests;
    };
    Dropdown.prototype.getBoost = function (value) {
        return value > 0 ? true : false;
    };
    Dropdown.prototype.renderRewardsDetails = function () {
        var _this = this;
        var props = __assign({}, this.props);
        var openChests = this.getChests(props.chestsCount);
        var boost = this.getBoost(props.boostRemaining);
        var isMobileCasino = inContext('CASINO-MOBILEWEB');
        props.onDropdownExpanded();
        return (h("div", { className: "srwrds-details", onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, style: __assign({}, this.transformScale(props.scaling)) },
            console.log('Tier Down:', props.showTierDown, 'Tier Up:', props.showTierUp),
            props.cvl2 &&
                this.panelItem(1, props.noOfPoints, h("svg", { viewBox: "0 0 16 24", className: props.cvl2 && props.showTierDown
                        ? 'srwrds-red'
                        : props.showTierUp && 'srwrds-blue' },
                    h("path", { d: "M15.15 12.75l-.69-1.33L8.88.55a1 1 0 0 0-1.76 0L1.54 11.42l-.69 1.33A7.79 7.79 0 0 0 8 24a7.79 7.79 0 0 0 7.15-11.25", fill: "#3f9041", "fill-rule": "evenodd" })), props.toWin),
            props.cvl2 &&
                props.boostEnabled &&
                this.panelItem(2, boost ? props.boostOnPoints : props.nextBoostNumber, h("svg", { viewBox: "0 0 16 24" },
                    h("path", { d: "M16 8.27a.52.52 0 0 0-.5-.27H9.22L12 .68a.52.52 0 0 0-.06-.47.51.51 0 0 0-.44-.21h-7a.5.5 0 0 0-.5.33l-4 11a.51.51 0 0 0 .06.46.51.51 0 0 0 .44.21h5.41L4 23.42a.49.49 0 0 0 .3.54.41.41 0 0 0 .19 0 .48.48 0 0 0 .4-.2l11-15a.51.51 0 0 0 0-.52", fill: "#fda926", "fill-rule": "evenodd" })), props.boostsDouble),
            props.cvl2 &&
                props.tierId < 6 &&
                this.panelItem(3, props.levelChestUpgrade, h("svg", { viewBox: "0 0 20 20" },
                    h("mask", { id: "a", height: "10", maskUnits: "userSpaceOnUse", width: "10", x: "0", y: "0" },
                        h("path", { d: "m0 0h10v10h-10z", fill: "#fff", "fill-rule": "evenodd" })),
                    h("path", { d: "m19.5 4h-5a.5.5 0 0 0 -.5.5v4.5h-4.5a.5.5 0 0 0 -.5.5v4.5h-4.5a.5.5 0 0 0 -.5.5v5a.5.5 0 0 0 1 0v-4.5h4.5a.5.5 0 0 0 .5-.5v-4.5h4.5a.5.5 0 0 0 .5-.5v-4.5h4.5a.5.5 0 0 0 0-1", fill: "#12100b", "fill-rule": "evenodd" }),
                    h("g", { mask: "url(#a)" },
                        h("path", { d: "m9 4.5a.5.5 0 0 0 1 0v-4a.43.43 0 0 0 0-.19.51.51 0 0 0 -.31-.31.41.41 0 0 0 -.19 0h-4a.5.5 0 0 0 -.5.5.5.5 0 0 0 .5.5h2.79l-8.14 8.15a.48.48 0 0 0 0 .7.47.47 0 0 0 .35.15.47.47 0 0 0 .35-.15l8.15-8.14z", fill: "#12100b", "fill-rule": "evenodd" }))), props.winChests),
            props.cvl2 &&
                props.expiresOn &&
                this.panelItem(4, props.expires + ' ' + props.expiresOn, h("svg", { viewBox: "0 0 24 24", className: props.cvl2 && props.showTierDown && "srwrds-red", xmlns: "http://www.w3.org/2000/svg" },
                    h("path", { d: "m12 .5a11.48 11.48 0 1 0 11.46 11.5 11.48 11.48 0 0 0 -11.46-11.5", fill: "#fff", opacity: ".01" }),
                    h("path", { d: "m12 0a12 12 0 1 0 12 12 12 12 0 0 0 -12-12m0 1a11 11 0 1 1 -11 11 11 11 0 0 1 11-11" }),
                    h("path", { d: "m16.47 18a.51.51 0 0 1 -.36-.15l-5.11-5.12v-5.25a.51.51 0 0 1 .51-.5.5.5 0 0 1 .5.5v4.83l4.84 4.81a.5.5 0 0 1 0 .71.51.51 0 0 1 -.36.15" })), props.youHave),
            props.cvl2 &&
                props.canExchange &&
                this.panelItem(5, props.exchange, h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 31.06 24" },
                    h("path", { d: "M30.85 7.26l-7.06-7a.7.7 0 0 0-1.2.5v3.47h-6.36a.71.71 0 0 0 0 1.42h7.06a.71.71 0 0 0 .71-.71V2.41l5.4 5.4-5.4 6.48V12a.71.71 0 0 0-.71-.71H8.47V7.76a.7.7 0 0 0-1.2-.5L.21 14.32a.72.72 0 0 0 0 1l7.06 8.47a.72.72 0 0 0 .54.25A.64.64 0 0 0 8 24a.71.71 0 0 0 .47-.67v-3.57h6.35a.7.7 0 0 0 .71-.7.71.71 0 0 0-.71-.71H7.76a.7.7 0 0 0-.7.71v2.28l-5.4-6.47 5.4-5.4V12a.7.7 0 0 0 .7.71h14.83v3.53a.7.7 0 0 0 .47.66.59.59 0 0 0 .23 0 .73.73 0 0 0 .55-.25l7.05-8.47a.71.71 0 0 0 0-1", fill: "#12100b", "fill-rule": "evenodd" })), props.youCompleted, h("div", { className: "srwrds-button srwrds-secondary", onClick: this.showExchangeForm }, props.exchangeNow)),
            props.cvl2 &&
                openChests &&
                this.panelItem(6, null, h("div", { className: "srwrds-chests srwrds-button", onClick: function () {
                        !_this.srwrdsOpenChestsDisabled
                            ? _this.dispatchGlobalEvt(Dropdown.EVENTS.OPEN_CHESTS)
                            : '';
                    } },
                    props.openChest,
                    " (",
                    props.chestsCount,
                    ")")),
            !props.cvl2 && (h("div", { className: "srwrds-panel" },
                h("svg", { viewBox: "0 0 28 28" },
                    h("path", { d: "M12,27A12,12,0,1,1,24,15,12,12,0,0,1,12,27Zm.15-18.46S8.39,15.63,8.39,17.7a3.76,3.76,0,1,0,7.51,0C15.9,15.63,12.15,8.55,12.15,8.55Z", fill: "#09b534" })),
                props.noOfPoints)),
            !props.cvl2 && (h("div", { className: "srwrds-panel" },
                h("svg", { viewBox: "0 0 28 28" },
                    h("path", { d: "M17.25,0h0L10.46,12.88H19.3L2.15,30,8.84,17.22H0L17.25,0", fill: "#fda926" })),
                boost ? props.boostOnPoints : props.nextBoostNumber)),
            !props.cvl2 && props.showTierUp && (h("div", { className: "srwrds-panel" },
                h("svg", { viewBox: "0 0 28 28" },
                    h("path", { d: "M20.12,26.85H14.9V14.8h4.16L11.82,6.21,4.58,14.8H9V26.85H3.63L0,23.12V6.64L3.63,3.15H20.12l3.53,3.48V23.12Z", fill: "#4fd6e2" })),
                props.noToUpgrade)),
            !props.cvl2 && openChests && (h("div", { className: "srwrds-chests", onClick: function () {
                    !_this.srwrdsOpenChestsDisabled
                        ? _this.dispatchGlobalEvt(Dropdown.EVENTS.OPEN_CHESTS)
                        : '';
                } },
                h("div", { className: "srwrds-anim", style: this.getImages.chestanim }),
                h("span", { className: "srwrds-nudge" }, this.getChests(props.chestsCount)),
                props.openChest)),
            !props.cvl2 && !openChests && (h("div", { className: "srwrds-nochests" },
                h("img", { src: this.imagePaths.nochest, alt: props.nextChestNo }),
                props.nextChestNo)),
            !props.cvl2 && (h("svg", { "data-id": "StarsRewardsLogo" },
                h("path", { d: "M4.25,27C.55,27-.14,24.81,0,22.34H3c0,1.36.06,2.51,1.7,2.51a1.43,1.43,0,0,0,1.5-1.62c0-2.57-6-2.73-6-7,0-2.23,1.07-4,4.7-4,2.9,0,4.35,1.3,4.15,4.29H6.14c0-1.07-.18-2.15-1.38-2.15A1.39,1.39,0,0,0,3.22,15.9c0,2.71,6,2.47,6,7,0,3.69-2.71,4.13-5,4.13", fill: "#fff" }),
                h("polygon", { points: "19.71 12.48 19.71 14.85 16.39 14.85 16.39 26.74 13.41 26.74 13.41 14.85 10.09 14.85 10.09 12.48 19.71 12.48", fill: "#fff" }),
                h("path", { d: "M18.7,26.74l4-14.26h3.93l3.87,14.26H27.31l-.79-3.16H22.45l-.81,3.16Zm5.75-11.52h0L23,21.39h2.84Z", fill: "#fff" }),
                h("path", { d: "M34.58,26.74h-3V12.48h5.51c2,0,3.34,1.3,3.34,3.73,0,1.82-.71,3.18-2.65,3.5v0a2.54,2.54,0,0,1,2.59,2.81,19.59,19.59,0,0,0,.34,4.19H37.8A6.55,6.55,0,0,1,37.48,24c0-1.7.16-3.14-2.13-3.14h-.77Zm0-8.1H35.9c1.19,0,1.52-1.19,1.52-2.09,0-1.36-.57-1.88-1.52-1.88H34.58Z", fill: "#fff" }),
                h("path", { d: "M46,27c-3.69,0-4.39-2.17-4.23-4.64h3c0,1.36.06,2.51,1.7,2.51A1.43,1.43,0,0,0,48,23.23c0-2.57-6-2.73-6-7,0-2.23,1.07-4,4.7-4,2.9,0,4.35,1.3,4.15,4.29h-2.9c0-1.07-.18-2.15-1.38-2.15A1.39,1.39,0,0,0,45,15.9c0,2.71,6,2.47,6,7C51,26.54,48.32,27,46,27", fill: "#fff" }),
                h("path", { d: "M111.68,26.74h-3V12.48h5.51c2,0,3.34,1.3,3.34,3.73,0,1.82-.71,3.18-2.65,3.5v0a2.53,2.53,0,0,1,2.59,2.81,19.53,19.53,0,0,0,.34,4.19H114.9a6.55,6.55,0,0,1-.32-2.77c0-1.7.16-3.14-2.13-3.14h-.77Zm0-8.1H113c1.19,0,1.52-1.19,1.52-2.09,0-1.36-.57-1.88-1.52-1.88h-1.32Z", fill: "#fff" }),
                h("polygon", { points: "119.24 26.74 119.24 12.48 127.03 12.48 127.03 14.67 122.23 14.67 122.23 18.19 126.65 18.19 126.65 20.38 122.23 20.38 122.23 24.55 127.19 24.55 127.19 26.74 119.24 26.74", fill: "#fff" }),
                h("polygon", { points: "127.92 12.48 130.98 12.48 132.84 22.5 132.88 22.5 135.13 12.48 138.65 12.48 140.78 22.5 140.82 22.5 142.6 12.48 145.52 12.48 142.36 26.74 139.06 26.74 136.83 16.31 136.79 16.31 134.32 26.74 131.08 26.74 127.92 12.48", fill: "#fff" }),
                h("path", { d: "M144.55,26.74l4-14.26h3.93l3.87,14.26h-3.14l-.79-3.16h-4.07l-.81,3.16Zm5.75-11.52h0l-1.36,6.16h2.84Z", fill: "#fff" }),
                h("path", { d: "M160.44,26.74h-3V12.48H163c2,0,3.34,1.3,3.34,3.73,0,1.82-.71,3.18-2.65,3.5v0a2.53,2.53,0,0,1,2.59,2.81,19.53,19.53,0,0,0,.34,4.19h-2.92a6.55,6.55,0,0,1-.32-2.77c0-1.7.16-3.14-2.13-3.14h-.77Zm0-8.1h1.32c1.19,0,1.52-1.19,1.52-2.09,0-1.36-.57-1.88-1.52-1.88h-1.32Z", fill: "#fff" }),
                h("path", { d: "M168,12.48h5c3.91,0,4.64,2.61,4.64,7.05,0,2.19.34,7.21-4.76,7.21H168Zm3,12.07h1.44c1.82,0,2.17-1.36,2.17-4.94,0-2.63,0-4.94-2.07-4.94H171Z", fill: "#fff" }),
                h("path", { d: "M183.33,27c-3.69,0-4.39-2.17-4.23-4.64h3c0,1.36.06,2.51,1.7,2.51a1.43,1.43,0,0,0,1.5-1.62c0-2.57-6-2.73-6-7,0-2.23,1.07-4,4.7-4,2.9,0,4.35,1.3,4.15,4.29h-2.9c0-1.07-.18-2.15-1.38-2.15a1.39,1.39,0,0,0-1.54,1.52c0,2.71,6,2.47,6,7,0,3.69-2.71,4.13-5,4.13", fill: "#fff" }),
                h("path", { d: "M75.46,10.87a.52.52,0,0,0,.49-.35S78.61,2.32,79.36,0l3.42,10.51a.51.51,0,0,0,.49.35h11l-8.94,6.5a.52.52,0,0,0-.21.42.46.46,0,0,0,0,.16l3.42,10.51-8.94-6.5a.52.52,0,0,0-.61,0l-8.94,6.5,3.41-10.51a.48.48,0,0,0,0-.16.52.52,0,0,0-.21-.42l-8.94-6.5Z", fill: "#e11b22" }),
                h("path", { d: "M77.78,13.68a.21.21,0,0,0,.2-.14l1.39-4.27,1.39,4.27a.21.21,0,0,0,.2.14h4.49l-3.64,2.64a.21.21,0,0,0-.09.17.19.19,0,0,0,0,.06l1.39,4.27-3.64-2.64a.21.21,0,0,0-.25,0l-3.63,2.64L77,16.56a.22.22,0,0,0,0-.06.21.21,0,0,0-.09-.17l-3.63-2.64Z", fill: "#fff" }),
                h("path", { d: "M59.55,18a.35.35,0,0,0,.34-.24l2.33-7.19,2.34,7.19a.35.35,0,0,0,.33.24h7.56l-6.12,4.45a.36.36,0,0,0-.15.29.31.31,0,0,0,0,.11L68.55,30l-6.12-4.45a.35.35,0,0,0-.42,0L55.9,30l2.34-7.19a.33.33,0,0,0,0-.11.36.36,0,0,0-.15-.29L52,18Z", fill: "#e11b22" }),
                h("path", { d: "M61.14,19.9a.14.14,0,0,0,.14-.1l.95-2.92,1,2.92a.14.14,0,0,0,.14.1h3.07l-2.49,1.81a.14.14,0,0,0-.06.12.13.13,0,0,0,0,0l1,2.92L62.31,23a.14.14,0,0,0-.17,0L59.65,24.8l1-2.92a.16.16,0,0,0,0,0,.14.14,0,0,0-.06-.12L58.06,19.9Z", fill: "#fff" }),
                h("path", { d: "M93.78,18a.35.35,0,0,0,.34-.24l2.33-7.19,2.34,7.19a.35.35,0,0,0,.33.24h7.56l-6.12,4.45a.36.36,0,0,0-.15.29.31.31,0,0,0,0,.11L102.77,30l-6.12-4.45a.35.35,0,0,0-.42,0L90.12,30l2.34-7.19a.33.33,0,0,0,0-.11.36.36,0,0,0-.15-.29L86.21,18Z", fill: "#e11b22" }),
                h("path", { d: "M95.36,19.9a.14.14,0,0,0,.14-.1l.95-2.92,1,2.92a.14.14,0,0,0,.14.1h3.07l-2.49,1.81a.14.14,0,0,0-.06.12.13.13,0,0,0,0,0l1,2.92L96.53,23a.14.14,0,0,0-.17,0L93.87,24.8l1-2.92a.16.16,0,0,0,0,0,.14.14,0,0,0-.06-.12L92.28,19.9Z", fill: "#fff" }))),
            !props.cvl2 && isMobileCasino && (h("div", { className: "srwrds-moreinfo", onClick: this.showMoreInformation },
                h("svg", { "data-id": "StarsRewardsInfo" },
                    h("circle", { cx: "11.42", cy: "11.42", r: "9.92", fill: "none", stroke: "#777", "stroke-linejoin": "round", "stroke-width": "2" }),
                    h("path", { d: "M13.62,7a1.39,1.39,0,0,1-1.39,1.31A1.26,1.26,0,0,1,10.95,7s0-.05,0-.08a1.39,1.39,0,0,1,1.39-1.31,1.26,1.26,0,0,1,1.28,1.23S13.62,6.93,13.62,7Zm-5,2.85a2.32,2.32,0,0,1,2.12-.7c1.59.09,1.64,1,1.65,1.36s-1,2.94-1.05,4.13,1.44.42,1.44.42.42.22,0,.59a4,4,0,0,1-2,.59c-.54,0-1.76-.4-1.71-1.58s1.75-4,1-4.46a1.14,1.14,0,0,0-1.12,0c-.55.24-.3-.31-.3-.31Z", fill: "#777" })),
                props.moreInfo)),
            !props.cvl2 && !isMobileCasino && (h("span", { className: "srwrds-moreinfo", onClick: this.showMoreInformation },
                h("svg", { "data-id": "StarsRewardsInfo" },
                    h("circle", { cx: "11.42", cy: "11.42", r: "9.92", fill: "none", stroke: "#777", "stroke-linejoin": "round", "stroke-width": "2" }),
                    h("path", { d: "M13.62,7a1.39,1.39,0,0,1-1.39,1.31A1.26,1.26,0,0,1,10.95,7s0-.05,0-.08a1.39,1.39,0,0,1,1.39-1.31,1.26,1.26,0,0,1,1.28,1.23S13.62,6.93,13.62,7Zm-5,2.85a2.32,2.32,0,0,1,2.12-.7c1.59.09,1.64,1,1.65,1.36s-1,2.94-1.05,4.13,1.44.42,1.44.42.42.22,0,.59a4,4,0,0,1-2,.59c-.54,0-1.76-.4-1.71-1.58s1.75-4,1-4.46a1.14,1.14,0,0,0-1.12,0c-.55.24-.3-.31-.3-.31Z", fill: "#777" }))))));
    };
    Dropdown.prototype.renderExchangePanel = function () {
        this.props.onDropdownExpanded();
        return (h("div", { className: "srwrds-details", onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, style: __assign({}, this.transformScale(this.props.scaling)) }, this.panelItem(7, null, h("div", { className: "exchange-form" },
            h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 31.06 24" },
                h("path", { d: "M30.85 7.26l-7.06-7a.7.7 0 0 0-1.2.5v3.47h-6.36a.71.71 0 0 0 0 1.42h7.06a.71.71 0 0 0 .71-.71V2.41l5.4 5.4-5.4 6.48V12a.71.71 0 0 0-.71-.71H8.47V7.76a.7.7 0 0 0-1.2-.5L.21 14.32a.72.72 0 0 0 0 1l7.06 8.47a.72.72 0 0 0 .54.25A.64.64 0 0 0 8 24a.71.71 0 0 0 .47-.67v-3.57h6.35a.7.7 0 0 0 .71-.7.71.71 0 0 0-.71-.71H7.76a.7.7 0 0 0-.7.71v2.28l-5.4-6.47 5.4-5.4V12a.7.7 0 0 0 .7.71h14.83v3.53a.7.7 0 0 0 .47.66.59.59 0 0 0 .23 0 .73.73 0 0 0 .55-.25l7.05-8.47a.71.71 0 0 0 0-1", fill: "#12100b", "fill-rule": "evenodd" })),
            h("div", { className: "exchange-info" }, this.props.doYouWantToExchange),
            h("div", { className: "exchange-info" },
                h("a", { onClick: this.showMoreInformation }, this.props.clickForMoreInfo)),
            h("div", { className: "srwrds-button srwrds-secondary", onClick: this.hideExchangeForm }, this.props.cancel),
            h("div", { className: "srwrds-chests srwrds-button", onClick: this.props.exchangeAction }, this.props.exchange)))));
    };
    Dropdown.prototype.render = function () {
        return this.state.showExchange ?
            this.renderExchangePanel() :
            this.renderRewardsDetails();
    };
    Dropdown.EVENTS = {
        OPEN_CHESTS: 'srwrdsOpenChests',
        INFO: 'srwrdsInfo',
    };
    return Dropdown;
}(Component));
export default Dropdown;
